import {View, IDate} from '@ab/components';
import React from 'react';
import tpl from './templates/interactive.jsx';
import Collection from './collections/main.cll.js';
import {TYPE_BRANCHES} from './variables';
import {api, get} from '../../config';
import mixins from '../../mixins';

export default class extends View {
    static displayName = 'ExchangeRates';

    static defaultProps = {
        date: new IDate('now'),
        type: TYPE_BRANCHES,
    };

    uiSubStates = {
        INTERACTIVE: 'interactive',
        ACTIVE: 'active',
    };

    templates = {
        [this.uiStates.INITIAL]: <div className="inline" />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.STANDBY]: <div className="inline" />,
        [this.uiStates.HIDDEN]: <div className="inline" />,
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            uiSubState: this.uiSubStates.INTERACTIVE,
            type: props.type,
            date: props.date,
            branchCourses: new Collection(),
            processingCourses: new Collection(),
        };

        return this;
    }

    componentWillReady(resolve) {
        this.load().then(resolve);

        return this;
    }

    async load() {
        let response = {};

        try {
            response = await fetch(api('API_COURSES_NEW'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({
                    lang: get('LANG'),
                    request_ref: mixins.requestRefUuid(),
                    sid: mixins.getCookie('skey'),
                    data: {},
                }),
            });
        } catch (error) {
            console.error('Error fetching exchange rates:', error);
            return;
        }
        const result = await response.json();
        this.setState({
            branchCourses: new Collection(result.data.branch_rates, {parse: true}),
            processingCourses: new Collection(result.data.cards_rates, {parse: true}),
        });
    }

    isUiSubStateActive() {
        return this.state.uiSubState === this.uiSubStates.ACTIVE;
    }

    activate() {
        this.setState({
            uiSubState: this.uiSubStates.ACTIVE,
        });
    }

    deactivate(event = {}) {
        if (event.nativeEvent) {
            event.stopPropagation();
        }

        this.setState({
            uiSubState: this.uiSubStates.INTERACTIVE,
        });
    }
}
